import _ from 'underscore';

import {
  NETWORK_HEALTH_GOOD,
  NETWORK_HEALTH_POOR,
  NETWORK_HEALTH_EXCELLENT
} from 'constants/NetworkHealth';
import { LIGHT_THEME } from 'constants/Theme';
import getElementHeight from 'utils/dimensions/getElementHeight';
import getElementWidth from 'utils/dimensions/getElementWidth';
import {
  _768P,
  _1280P,
  _1440P,
  _1920P,
  _768P_SIDE_PANEL_WIDTH,
  _1280P_SIDE_PANEL_WIDTH,
  _1440P_SIDE_PANEL_WIDTH,
  _1920P_SIDE_PANEL_WIDTH
} from './constants/ScreenDimensions';
import { getURLPathParams } from '@studio/logger/utils/getURLPathParams';

export const goToJoinPage = () => {
  const pathParams = getURLPathParams();

  const teamId = pathParams?.teamId;
  const eventId = pathParams?.eventId;
  const broadcastId = pathParams?.broadcastId;
  window.location.href = `/studio-presenter/teams/${teamId}/events/${eventId}/broadcasts/${broadcastId}/join${window.location.search}`;
};

export const getCenterPanelWidth = () => getElementWidth('#center-panel');

export const getPageWidth = () => getElementWidth('body');

export const getProgramWidth = () => getElementWidth('#program-area');

export const getLeftPanelWidth = () => getElementWidth('#left-panel');

export const getLocalTileWidth = () =>
  getElementWidth('#local-tile-video-wrapper');

export const getLocalTileHeight = () =>
  getElementHeight('#local-tile-video-wrapper');

export const getLocalTileTitleHeight = () =>
  getElementHeight('#local-tile-title');

export const getSidePanelWidth = pageWidth => {
  if (pageWidth >= _1920P) {
    return (pageWidth * _1920P_SIDE_PANEL_WIDTH) / 100;
  } else if (pageWidth >= _1440P) {
    return (pageWidth * _1440P_SIDE_PANEL_WIDTH) / 100;
  } else if (pageWidth >= _1280P) {
    return (pageWidth * _1280P_SIDE_PANEL_WIDTH) / 100;
  } else if (pageWidth >= _768P) {
    return (pageWidth * _768P_SIDE_PANEL_WIDTH) / 100;
  }
};

export const sanitizeHTML = function (str) {
  return str.replace(/[^\w. ]/gi, function (c) {
    return '&#' + c.charCodeAt(0) + ';';
  });
};

export const getNetworkQuality = bandwidth => {
  if (bandwidth >= 1400) {
    return NETWORK_HEALTH_EXCELLENT;
  } else if (bandwidth >= 650) {
    return NETWORK_HEALTH_GOOD;
  } else {
    return NETWORK_HEALTH_POOR;
  }
};

const WAIT = 7000;

export class BandwidthChangeHandler {
  constructor(callback) {
    this.currentBandwidth = null;
    this.throttledCallback = _.throttle(newBandwidth => {
      callback(newBandwidth);
      this.currentBandwidth = newBandwidth;
    }, WAIT);
  }

  onChange(newBandwidth) {
    if (isNaN(newBandwidth)) return;
    // update - needs to be throttled
    if (
      this.currentBandwidth === null ||
      this.getQualityHasChanged(newBandwidth)
    ) {
      this.fireCallback(newBandwidth);
    }
  }

  getQualityHasChanged(newBandwidth) {
    return (
      getNetworkQuality(newBandwidth) !==
      getNetworkQuality(this.currentBandwidth)
    );
  }

  fireCallback(newBandwidth) {
    this.throttledCallback(newBandwidth);
  }
}

/**
 * Determines if the user is in light theme mode
 * @param {object} props - react props object
 */
export const isLightTheme = props => {
  return props?.theme?.id === LIGHT_THEME;
};
